/* InteriorExotics PDP enhancements: drag-to-explore viewer, sticky add to cart, delivery estimate. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Drag-to-explore viewer ---------- */
  function initInspect(root) {
    const dialog = root.querySelector('[data-ie-inspect]');
    const openBtn = root.querySelector('[data-ie-inspect-open]');
    if (!dialog || !openBtn) return;

    const images = JSON.parse(dialog.querySelector('[data-ie-inspect-data]').textContent);
    const stage = dialog.querySelector('[data-ie-inspect-stage]');
    const img = dialog.querySelector('[data-ie-inspect-img]');
    const indexEl = dialog.querySelector('[data-ie-inspect-index]');
    const progress = dialog.querySelector('[data-ie-inspect-progress]');
    const hint = dialog.querySelector('[data-ie-inspect-hint]');
    const cache = new Map();
    const STEP_PX = 70; // drag distance that turns to the next angle

    let index = 0;
    let scale = 1;
    let tx = 0;
    let ty = 0;

    const preload = (i) => {
      const n = (i + images.length) % images.length;
      if (cache.has(n)) return;
      const im = new Image();
      im.decoding = 'async';
      im.src = images[n].src;
      cache.set(n, im);
    };

    const apply = () => {
      img.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`;
      stage.classList.toggle('is-zoomed', scale > 1);
    };

    const show = (i) => {
      index = (i + images.length) % images.length;
      img.src = images[index].src;
      img.alt = images[index].alt;
      indexEl.textContent = index + 1;
      progress.style.width = `${((index + 1) / images.length) * 100}%`;
      preload(index + 1);
      preload(index - 1);
    };

    const setZoom = (next, cx = 0, cy = 0) => {
      const s = Math.min(4, Math.max(1, next));
      // keep the point under the cursor fixed while zooming
      tx = cx - ((cx - tx) * s) / scale;
      ty = cy - ((cy - ty) * s) / scale;
      scale = s;
      if (scale === 1) tx = ty = 0;
      apply();
    };

    const centerOffset = (e) => {
      const r = stage.getBoundingClientRect();
      return [e.clientX - r.left - r.width / 2, e.clientY - r.top - r.height / 2];
    };

    // pointer handling: one pointer drags (turn or pan), two pointers pinch
    const pointers = new Map();
    let startX = 0;
    let startY = 0;
    let startIndex = 0;
    let startTx = 0;
    let startTy = 0;
    let pinchDist = 0;
    let pinchScale = 1;
    let lastTap = 0;

    stage.addEventListener('pointerdown', (e) => {
      stage.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, e);
      hint.classList.add('is-hidden');
      if (pointers.size === 2) {
        const [a, b] = [...pointers.values()];
        pinchDist = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        pinchScale = scale;
        return;
      }
      startX = e.clientX;
      startY = e.clientY;
      startIndex = index;
      startTx = tx;
      startTy = ty;
      const now = Date.now();
      if (now - lastTap < 300) setZoom(scale > 1 ? 1 : 2.5, ...centerOffset(e));
      lastTap = now;
    });

    stage.addEventListener('pointermove', (e) => {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, e);
      if (pointers.size === 2) {
        const [a, b] = [...pointers.values()];
        const d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        setZoom((pinchScale * d) / pinchDist);
        return;
      }
      if (scale > 1) {
        tx = startTx + (e.clientX - startX);
        ty = startTy + (e.clientY - startY);
        apply();
      } else {
        const steps = Math.round((startX - e.clientX) / STEP_PX);
        if ((startIndex + steps) % images.length !== index) show(startIndex + steps);
      }
    });

    const release = (e) => pointers.delete(e.pointerId);
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);

    stage.addEventListener(
      'wheel',
      (e) => {
        e.preventDefault();
        setZoom(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), ...centerOffset(e));
      },
      { passive: false }
    );

    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') show(index + 1);
      if (e.key === 'ArrowLeft') show(index - 1);
    });
    dialog.querySelector('[data-ie-inspect-prev]').addEventListener('click', () => show(index - 1));
    dialog.querySelector('[data-ie-inspect-next]').addEventListener('click', () => show(index + 1));
    dialog.querySelector('[data-ie-inspect-zoom]').addEventListener('click', () => setZoom(scale > 1 ? 1 : 2.5));
    dialog.querySelector('[data-ie-inspect-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      setZoom(1);
      document.documentElement.classList.remove('ie-inspect-lock');
    });

    openBtn.addEventListener('click', () => {
      // start on the image currently active in the theme gallery
      const active = root.querySelector('.product__media-item.is-active img, .product__media-item img');
      const activeSrc = active ? (active.currentSrc || active.src).split('?')[0].split('_')[0] : '';
      const start = Math.max(0, images.findIndex((m) => activeSrc && m.src.includes(activeSrc.split('/').pop())));
      show(start);
      hint.classList.remove('is-hidden');
      dialog.showModal();
      document.documentElement.classList.add('ie-inspect-lock');
      stage.focus();
      if (!reduceMotion) {
        // a short auto-turn teaches the drag gesture
        let n = 0;
        const t = setInterval(() => {
          if (pointers.size || ++n > 3 || !dialog.open) return clearInterval(t);
          show(index + 1);
        }, 420);
      }
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(bar) {
    const section = bar.dataset.section;
    const form = document.getElementById(`product-form-${section}`);
    const submit = form && form.querySelector('[name="add"]');
    if (!submit) return;
    const btn = bar.querySelector('[data-ie-sticky-btn]');
    const priceOut = bar.querySelector('[data-ie-sticky-price]');
    const variantOut = bar.querySelector('[data-ie-sticky-variant]');

    const sync = () => {
      const price = document.querySelector(`#price-${section} .price-item--last, #price-${section} .price-item--regular`);
      if (price) priceOut.textContent = price.textContent.trim();
      const checked = [...document.querySelectorAll(`#variant-selects-${section} input:checked, #variant-selects-${section} select`)]
        .map((el) => (el.tagName === 'SELECT' ? el.selectedOptions[0]?.textContent : el.value))
        .filter(Boolean);
      variantOut.textContent = checked.join(' / ') + (checked.length ? ' ·' : '');
      btn.disabled = submit.disabled;
      btn.textContent = submit.disabled ? submit.textContent.trim() : 'Add to cart';
    };

    btn.addEventListener('click', () => submit.click());
    new MutationObserver(sync).observe(form, { subtree: true, attributes: true, childList: true });
    document.addEventListener('change', (e) => {
      if (e.target.closest(`#variant-selects-${section}`)) setTimeout(sync, 250);
    });
    sync();

    bar.hidden = false;
    new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('ie-sticky-atc-on', past);
    }).observe(submit);
  }

  /* ---------- Delivery estimate ---------- */
  function initEta(el) {
    const add = (d) => {
      const date = new Date();
      date.setDate(date.getDate() + d);
      return date;
    };
    const fmt = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' });
    el.querySelector('[data-ie-eta-range]').textContent =
      `${fmt.format(add(+el.dataset.minDays))} – ${fmt.format(add(+el.dataset.maxDays))}`;
  }

  const boot = () => {
    document.querySelectorAll('.product').forEach(initInspect);
    document.querySelectorAll('[data-ie-sticky-atc]').forEach(initSticky);
    document.querySelectorAll('[data-ie-eta]').forEach(initEta);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
